export const commonOverlayOptions = {
  draggable: true,
  editable: true,
  fillColor: '#154a93',
  fillOpacity: 0.7,
  geodesic: true,
  strokeColor: '#154a93',
  strokeWeight: 3,
};

export const infoBubbleBottomPadding = 20;
export const infoBubbleMouseBuffer = 40;